import BaseTextField from "components/base/TextField"
import useInput from "hooks/use_input"
import useTranslation from "hooks/use_translation"

const LastName = () => {
  const id = "last_name"

  const { fields } = useTranslation()
  const validate = (value) => {
    if (value === "") return fields?.required

    return ""
  }

  const { handleChange, inputValue, errorMessage, handleBlur } = useInput(id, validate)

  return (
    <BaseTextField
      id={id}
      _label={fields?.last_name_title}
      // placeholder={fields?.last_name?.title}
      value={inputValue}
      onChange={handleChange}
      error={errorMessage?.length > 0}
      onBlur={handleBlur}
      helperText={errorMessage}
    />
  )
}

export default LastName
